import { gql } from 'apollo-boost';
import { MESSAGE_FRAGMENT } from './message-fragment';
import { SYSTEM_CHAT_USER_FRAGMENT } from './system-chat-user-fragment';

export const ADMIN_CONVERSATION_FRAGMENT = gql`
  ${MESSAGE_FRAGMENT}
  ${SYSTEM_CHAT_USER_FRAGMENT}

  fragment adminConversationFragment on Conversation {
    id
    updated_at
    business_unread_messages_count
    last_message_sent
    last_message {
      ...messageFragment
    }
    ...systemChatUserKeys
  }
`;
